import "./HybridTranslationsLoader"

var module = angular.module("ResearchKitApplicationModule");

/*
 * A service to provide consistent configuration and wrappers around the angular-translate service in the many places it is used.
 */
module.factory("translateConfiguration",
  function () {

    function configure($translateProvider, availableLocales, forDesigner) {

        var availableKeys = [];
        var fallbackKeys = {};

        _.each(availableLocales, function(locale) {
            availableKeys.push(locale.Code);
            if (locale.Code.indexOf("-") === -1) {
                fallbackKeys[locale.Code + "-*"] = locale.Code;
            }
            if (locale.IsDefault) {
                fallbackKeys[locale.Code + "-*"] = locale.Code;
            }
        });
        _.each(availableLocales, function(locale) {
            //Required to provide a language to folks whose browser's "preferred language" isn't one of our Localization options.
            //Needs to be the last fallbackKeys entry added, otherwise it will override more specific options.
            if (locale.IsDefault) {
                fallbackKeys["*"] = locale.Code;
            }
        });

        $translateProvider
            .uniformLanguageTag("bcp47")
            .registerAvailableLanguageKeys(availableKeys, fallbackKeys)
            .useSanitizeValueStrategy('sanitizeParameters');

        if (!forDesigner) {
            $translateProvider
                .determinePreferredLanguage()
                .storageKey('preferred-language')
                .useStorage('localizationCookieStorage');
        }
        
        $translateProvider.useLoader('hybridTranslationsLoader');

        $translateProvider.fallbackLanguage('en');
    }

    return {
        configure: function ($translateProvider, forDesigner) { return configure($translateProvider, forDesigner); },
    };
});